import { Button, Input, InputPassword } from '@vrplatform/components';
import { Anchor, Box, rem } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Controller, useForm } from 'react-hook-form';
import { validateEmail } from '../../../../utils';
import { ForgotPasswordModal } from '../../components/ForgotPasswordModal';
import type { SignInFormInputs, useSignInForm } from '../../hooks';
import { InputWrapper } from './InputWrapper';
import { useIsSignInMobile } from './useIsSignInMobile';

type Props = ReturnType<typeof useSignInForm>;

export const SignIn = (props: Props) => {
  return (
    <>
      {/* SSO Buttons */}
      {/* <SocialAuthButtons signInWithSocials={signInWithSocials} /> */}

      {/* Email Form */}
      <Form {...props} />
    </>
  );
};

const Form = ({ loading, submitLogin, triggerPasswordReset }: Props) => {
  const [opened, handlers] = useDisclosure(false);

  const isMobile = useIsSignInMobile();

  const { formState, handleSubmit, watch, control } = useForm<SignInFormInputs>(
    { mode: 'onChange' }
  );

  const email = watch('email');

  return (
    <Box
      sx={{
        maxWidth: 400,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 17,
        justifyContent: 'center',
        marginTop: '8dvh',
      }}
    >
      <Box
        onSubmit={handleSubmit(submitLogin)}
        component="form"
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing.xs,
        })}
      >
        <InputWrapper label={'Email'}>
          <Controller
            control={control}
            name={'email'}
            defaultValue={''}
            rules={{
              validate: (value) => validateEmail(value, { required: true }),
            }}
            render={({ field }) => (
              <Input
                {...field}
                placeholder={'Email'}
                type={'email'}
                id="email"
                autoComplete="username"
                mb="md"
              />
            )}
          />
        </InputWrapper>
        <InputWrapper label={'Password'}>
          <Controller
            control={control}
            name={'password'}
            defaultValue={''}
            rules={{ required: true }}
            render={({ field }) => (
              <InputPassword
                {...field}
                value={field.value ?? ''}
                placeholder={'Password'}
                id="password"
                autoComplete="current-password"
                h="auto"
                withPopover={false}
                visibilityToggleButtonProps={{
                  'aria-label': 'Toggle password visibility',
                }}
              />
            )}
          />
        </InputWrapper>
        <Anchor
          onClick={(event) => {
            event.preventDefault();
            handlers.open();
          }}
          component="button"
          type="button"
          p={0}
          data-testid="password-reset"
          // h="auto"
          // mih={'auto'}
          size="xs"
          sx={(theme) => ({
            borderRadius: theme.radius.sm,
            fontWeight: 400,
            lineHeight: '1rem',
            alignSelf: 'flex-start',
          })}
        >
          Forgot Password
        </Anchor>
        <Button
          variant="primary"
          id="signInButton"
          type="submit"
          sx={(theme) => ({
            width: '100%',
            marginTop: isMobile ? rem(30) : rem(90),
            marginBottom: theme.spacing.lg,
            borderRadius: theme.radius.md,
          })}
          loading={loading}
          disabled={!formState.isValid}
        >
          Sign In
        </Button>

        <ForgotPasswordModal
          opened={opened}
          close={handlers.close}
          email={email}
          onSubmit={triggerPasswordReset}
        />
      </Box>
    </Box>
  );
};
